import get from 'lodash/get';
export const getMaxAssetCount = (state: any) =>
  get(
    state,
    'user.user.organization.kvp.features.tdoLimits.maxAssetCount',
    100
  );
